"use strict";
var React = require("react");
var ReactDOM = require('react-dom');
var InventoryStore = require("../../stores/InventoryStore");
var InventoryActions = require("../../actions/InventoryActions")
var CompanyStore = require("../../stores/CompanyStore");
var CompanyActions = require("../../actions/CompanyActions");
var AuthStore = require("../../stores/AuthenticationStore");
var AuthActions = require("../../actions/AuthenticationActions");
var SubHeader = require("./InventorySubHeader.react");
var XMLUrlModal = require("./XMLUrlModal.js");
var EquipmentListFilter = require("./EquipmentListFilter.react");
import Item from './Item.react';
var Spinner = require('react-spinkit');
var AddInventoryModal = require("./AddInventoryItemFormModal");
var EditInventoryItemModal = require("./EditInventoryItemFormModal.js");
var DeleteInventoryItemModal = require("./DeleteInventoryItemFormModal.js");
var SellInventoryItemFormModal = require("./SellInventoryItemFormModal.js");
var InsureInventoryItemFormModal = require("./InsureInventoryItemFormModal.js");
var _ = require("underscore");
var clone = require("clone");
var cx = require("classnames");
require('bootstrap');
var moment = require('moment');

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

var Inventory = React.createClass({
    getInitialState: function() {
      var newState = InventoryStore.getState();
      newState.showSpinner = newState.loading;
      newState.showXMLModal = false;
      newState.openInventoryId = this.state ? this.state.openInventoryId : null;
      newState.openSubInventoryId = this.state ? this.state.openSubInventoryId : null;
      newState.showModal = this.state ? this.state.showModal : false;
      newState.showDeleteModal = this.state ? this.state.showDeleteModal : false;
      newState.showEditModal = this.state ? this.state.showEditModal : false;
      newState.showAddModal = this.state ? this.state.showAddModal : false;
      newState.showSellModal = this.state ? this.state.showSellModal : false;
      newState.showInsureModal = this.state ? this.state.showInsureModal : false;
      newState.selectedEquipmentToInsure = {};
      newState.valueToInsure = 0;

      return newState;
    },
    componentDidMount: function() {
      InventoryActions.clearFilter();
      InventoryStore.listen(this.onChange);
      CompanyStore.listen(this.onChange);
    },
    componentWillUnmount: function() {
      InventoryStore.unlisten(this.onChange);
      CompanyStore.unlisten(this.onChange);
    },
    onChange: function() {
      this.setState(this.getInitialState());
      if (this.state.items.length !== 0 && this.state.openInventoryId !== null) {
        if (this[this.state.openInventoryId]) {
          this[this.state.openInventoryId].scrollIntoView(false);
        }
      }
    },
    toggleOpen: function(key) {
      const open = this.state.openInventoryId === key;
      const id = open ? null : key;
      this.setState({ openInventoryId: id });
    },
    addEquipmentToInsurance: function(equipment) {
      const insureArray = this.state.selectedEquipmentToInsure;
      const eqId = equipment.id;
      const eqValue = parseFloat(equipment.purchase_price);
      var currentValueToInsure = parseFloat(this.state.valueToInsure);

      if(insureArray[eqId]) {
        delete insureArray[eqId];
        currentValueToInsure = currentValueToInsure-eqValue;
      } else {
        insureArray[eqId] = equipment;
        currentValueToInsure = currentValueToInsure+eqValue;
      }
      this.setState({
        selectedEquipmentToInsure: insureArray,
        valueToInsure: currentValueToInsure
      });
    },
    insureSpecificEquipment: function(equipment) {
      const insureArray = {};
      const eqId = equipment.id;
      const eqValue = parseFloat(equipment.purchase_price);

      insureArray[eqId] = equipment;

      this.setState({
        selectedEquipmentToInsure: insureArray,
        valueToInsure: eqValue
      });
      this.openInsure();
    },
    uninsureEquipment: function(eq){
      var answer = window.confirm("Ertu viss um að þú viljir hætta með þessa tryggingu?")
      if (answer) {
        eq.insured = false;
        InventoryActions.editItem(eq);
      }

    },
    mapEquipment: function(result, group, key) {
      var equipment = clone(result);
      if(equipment.ref) {
        // If the object has a ref attribute then its from the search
        // Ref is the index of the item in the equipmentList
        // Then we have to find the right object and then connect it
        equipment = this.state.items[result.ref];
      }
      return(
        <div
          key={key}
          ref={(element) => { this[key] = element; }}
        >
          <Item
            id={key}
            toggleOpen={this.toggleOpen.bind(this, key)}
            equipment={equipment}
            open={
              (this.state.openInventoryId === key) ? true : false
            }
            isHidden={false}
            openSell={this.openSell}
            openInsure={this.openInsure}
            openDelete={this.openDelete}
            openEdit={this.openEdit}
            openAdd={this.openAdd}
            quanity={group.length}
            group={group}
            selectedEquipmentToInsure={this.state.selectedEquipmentToInsure}
            addEquipmentToInsurance={this.addEquipmentToInsurance}
            uninsureEquipment={this.uninsureEquipment}
            insureSpecificEquipment={this.insureSpecificEquipment}
          />
        </div>
      );
    },
    // Is not in use at the moment
    // mapGroups is for making the creation_date groups (after months)
    mapGroups: function(result, key) {
      var itemList = _.indexBy(result, 'name');

      return (
        <div key={key}>
          {_.map(itemList, (item) => { return this.mapEquipment(item, result, key); })}
        </div>
      );
    },
    updateFilter: function(newFilter) {
      this.setState({filter: newFilter});
    },
    showXMLModal(){
      this.setState({ showXMLModal: true });
    },
    closeXMLModal(){
      this.setState({ showXMLModal: false });
    },
    sortRowsBy: function(field){
      var items_sorted = _.sortBy(this.state.items, function(obj){
        if (obj.field != null) {
          var name = obj.field.toLowerCase();
        }
        return name;
      });
      var items_list = items_sorted;
      _.map(items_sorted, this.mapEquipment)
    },
    close: function(){
      this.setState({ showModal: false });
    },
    open: function(){
      this.setState({ showModal: true });
    },
    closeDelete(){
      this.setState({ showDeleteModal: false });
    },
    openDelete(){
      this.setState({ showDeleteModal: true });
    },
    closeEdit(e) {
      this.setState({ showEditModal: false });
    },
    openEdit(e, subItem) {
      this.setState({
        showEditModal: true,
        openSubInventoryId: typeof subItem === 'number' ? subItem : null,
      });
    },
    closeAdd(){
      this.setState({ showAddModal: false });
    },
    openAdd(){
      this.setState({ showAddModal: true });
    },
    closeSell(){
      this.setState({ showSellModal: false });
    },
    openSell(){
      this.setState({ showSellModal: true });
    },
    closeInsure(){
      this.setState({ showInsureModal: false });
    },
    openInsure(){
      this.setState({ showInsureModal: true });
    },
    render: function() {
       var items_sorted = _.sortBy(this.state.items, function(obj) {
        if (obj.name != null) {
          var name = obj.name.toLowerCase();
        }
        return name;
       });
        var items_list = _.groupBy(items_sorted, function(item) { return item.name; });
        var eqListClass = cx({
            "equipment-list-container": true
        });
        var value = 0;
        var insuredValue = 0;
        _.countBy(this.state.items, function(item){
          value += parseInt(item.purchase_price);
          if(item.insured) {
            insuredValue += parseInt(item.purchase_price);
          }
        });

        var export_link = "#";
        var xml_link = "";
        if(this.state.filterId){
          export_link = "/export/" + this.state.filterId;
          xml_link = "/xml/" + this.state.filterId;
        }

        var insureIconListClass = cx({
            "fab-button": true,
            "insure": true,
            "pulse": true,
            "active": (this.state.valueToInsure > 0)
        });

        return (
          <div className="content_section margin_subnav">
            <AddInventoryModal
              show={this.state.showModal}
              onHide={this.close}
            />
            <AddInventoryModal
              show={this.state.showAddModal}
              onHide={this.closeAdd}
              cloneData={items_list[_.keys(items_list)[this.state.openInventoryId]] ? items_list[_.keys(items_list)[this.state.openInventoryId]][0] : {}}
            />
            <DeleteInventoryItemModal
              equipment={items_list[_.keys(items_list)[this.state.openInventoryId]] ? items_list[_.keys(items_list)[this.state.openInventoryId]][0] : {}}
              show={this.state.showDeleteModal}
              onHide={this.closeDelete}
            />
            <EditInventoryItemModal
              equipment={
                items_list[_.keys(items_list)[this.state.openInventoryId]] ?
                  items_list[_.keys(items_list)[this.state.openInventoryId]][this.state.openSubInventoryId ? this.state.openSubInventoryId : 0]
                :
                  {}
              }
              show={this.state.showEditModal}
              onHide={this.closeEdit}
            />
            <SellInventoryItemFormModal
              equipment={items_list[_.keys(items_list)[this.state.openInventoryId]] ? items_list[_.keys(items_list)[this.state.openInventoryId]][0] : {}}
              show={this.state.showSellModal}
              onHide={this.closeSell}
            />
            <InsureInventoryItemFormModal
              equipment={this.state.selectedEquipmentToInsure}
              valueToInsure={this.state.valueToInsure}
              show={this.state.showInsureModal}
              onHide={this.closeInsure}
            />
            <button
              id="openAddInventoryModal"
              className="fab-button"
              type="button"
              title="Bæta við búnaði"
              onClick={this.open}
            >
              <span className="md md-add"></span>
            </button>

            <button
              type="button"
              className={insureIconListClass}
              title="Tryggja búnað"
              onClick={this.openInsure}
            >
              <span className="fal fa-shield-check" />
              <div className="insure-button-info">{numberWithCommas(this.state.valueToInsure)} kr. ({_.size(this.state.selectedEquipmentToInsure)})</div>
            </button>

            <SubHeader updateFilter={this.updateFilter} />
            <div className="equipment-list-actions">
              <div className="row filter-stats">
                <div className="col-md-4">
                  <div className="stat-item">
                    <div className="stat-item-icon">
                      <i className="fal fa-box-alt"></i>
                    </div>
                    <div>
                      <span className="title">Búnaður skráður:</span>
                      <span className="value">{numberWithCommas(_.size(this.state.items))}</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-item">
                    <div className="stat-item-icon">
                      <i className="fal fa-box-usd"></i>
                    </div>
                    <div>
                      <span className="title">Verðmæti búnaðar:</span>
                      <span className="value">{numberWithCommas(value)} kr.</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-item">
                    <div className="stat-item-icon insured-icon">
                      <i className="fal fa-shield-check"></i>
                    </div>
                    <div>
                      <span className="title">Tryggð verðmæti:</span>
                      <span className="value">{numberWithCommas(insuredValue)} kr.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                  <div className="right-actions">
                    <div className="action-item">
                      <div className="btn-group">
                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Flytja út <span className="caret"></span>
                        </button>
                        <ul className="dropdown-menu">
                          <li><a href={export_link} target="_blank">Sækja Excel skrá</a></li>
                          <li role="separator" className="divider"></li>
                          <li><a href="#" onClick={this.showXMLModal}>XML Gagnatengill</a></li>
                        </ul>
                      </div>
                    </div>
                    <XMLUrlModal xmlUrl={xml_link} show={this.state.showXMLModal} onHide={this.closeXMLModal}/>
                  </div>
              </div>
            </div>
            <div id="equipmentList">
              <div className={eqListClass}>
                <div className="equipment-list-item-wrapper title">
                    <div className="equipment-list-item">
                      <div className="eq eq-status"></div>
                      <div className="eq eq-brand">Vörumerki</div>
                      <div className="eq eq-title" onClick={this.sortRowsBy.bind(this, "name")}>Vara</div>
                      {/* <div className="eq eq-loc">Staðsetning</div> */}
                      <div className="eq eq-type">Tegund</div>
                      <div className="eq eq-loc">Staðsetning</div>
                      <div className="eq eq-date">Skráningardagur</div>
                      <div className="eq eq-date">Kaupdagur</div>
                      <div className="eq eq-price">Kaupverð</div>
                      <div className="eq eq-readable"></div>
                      <div className="eq eq-checkbox"></div>
                    </div>
                </div>
                <div className="list-seperator"></div>
                {this.state.showSpinner ?
                  <Spinner name='three-bounce'/>
                :
                  Object.keys(items_list).map((item, key) => {
                    return this.mapGroups(items_list[item], key);
                  })
                }
                {(!this.state.showSpinner && _.isEmpty(this.state.items)) &&
                  <div className="empty-list">
                    <h2>Listinn er tómur</h2>
                    <p>Bættu í listann með því að smella á plúsinn niðri í hægra horninu!</p>
                    <i className="fal fa-align-slash"></i>
                  </div>
                }
              </div>
            </div>
          </div>
        );
    }
});

module.exports = Inventory;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/Inventory.react.js